import {
	Layout,
	Breakpoints,
	Container,
	ContainerPadding,
	ContainerGutter,
	TokenTextAppearance,
	TokenTextColor,
	TextAlignment,
	Text,
} from '@volkswagen-onehub/components-core';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { HuchaCard } from './hucha/components/card/hucha-card';
import { PortalContext } from '../../context/PortalContext';
import { useHuchaValues } from './hucha/hooks/use-hucha-values';
import { PersonBonus } from '@esportal/portal-service';
import { MyBonus } from '../my-bonus/my-bonus';

const Background = styled.div`
	background: #dfe4e8;
`;

export const Benefits: React.FC<{
	personBonus: PersonBonus | null;
}> = ({ personBonus }) => {
	const { portalService } = React.useContext(PortalContext);
	const sectionRef = useRef<HTMLElement>(null);
	const userData = portalService?.getPerson()?.getValue();
	const huchaValues = useHuchaValues(userData);
	const bonusRef = React.useRef<HTMLDivElement | null>(null);

	return (
		<Background>
			<section ref={sectionRef}>
				<Container
					data-testid="agenda-container"
					padding={{
						top: ContainerPadding.dynamic0150,
						bottom: ContainerPadding.dynamic0150,
					}}
					wrap="always"
					gutter={ContainerGutter.dynamic0100}
				>
					<Layout
						data-testid="benefits-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'benefits-section', columns: 22 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						<Container data-testid="benefits-container" gutter={ContainerGutter.dynamic0100} wrap="always">
							<Container data-testid="top-text" wrap={'always'}>
								<Text
									appearance={TokenTextAppearance.bigcopy200}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
									bold
								>
									Beneficios
								</Text>
								<Text
									appearance={TokenTextAppearance.headline500}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
								>
									Para ti, por <b>ser del club</b>
								</Text>
							</Container>
						</Container>
					</Layout>

					<Layout
						data-testid="my-bonus-layout"
						appearance={{
							[Breakpoints.default]: [{ name: 'my-bonus-section', columns: 24 }],
						}}
					>
						<MyBonus personBonus={personBonus} bonusRef={bonusRef} userData={userData} />
					</Layout>

					<Layout
						data-testid="hucha-layout"
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 1 },
								{ name: 'hucha-section', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 3 },
								{ name: 'hucha-section', columns: 18 },
								{ name: '.', columns: 3 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 5 },
								{ name: 'hucha-section', columns: 14 },
								{ name: '.', columns: 5 },
							],
						}}
					>
						<Container data-testid="hucha-container" gutter={ContainerGutter.dynamic0100} wrap="always">
							<Text
								appearance={TokenTextAppearance.headline400}
								color={TokenTextColor.primary}
								textAlign={TextAlignment.left}
							>
								<b>Ahorro acumulado</b> para tu próximo Volkswagen
							</Text>
							<HuchaCard huchaValues={huchaValues} />
						</Container>
					</Layout>
				</Container>
			</section>
		</Background>
	);
};
